export default "__VITE_PUBLIC_ASSET__c31eb89e__"